export const isCatalogEntryCarouselDefaultHidden = (id: string) =>
	id.toUpperCase().includes('_HIDDEN');
